import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { sanitize } from '../../../../lib/helpers';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

const messageStyles = makeStyles((theme) => ({
  paper: {
    margin: theme.spacing(2, 0),
    padding: theme.spacing(1)
  }
}));

const Message = (props) => {
  const classes = messageStyles();
  return(
    <Paper elevation={0} variant="outlined" className={classes.paper}>
      {props.user && <Typography>{props.user.first_name} {props.user.last_name}</Typography> }
      <Typography variant="overline">{moment.utc(props.created).tz(moment.tz.guess(true)).format('lll z')}</Typography>
      <Divider />
      <span
        dangerouslySetInnerHTML={sanitize(props.body, {
          html: true,
          safe: true,
        })}
      />
    </Paper>
  )
}

const mapStateToProps = (state, props) => {
  return {
    user: state.users.byId[props.sender]
  }
};

export default connect(mapStateToProps)(Message);